import React from "react";
import {
  DataKindMaintenancePageContent,
  DataKindMaintenancePageStateProvider,
} from ".";

export const DataKindMaintenancePage = () => {
  return (
    <>
      <DataKindMaintenancePageStateProvider>
        <DataKindMaintenancePageContent></DataKindMaintenancePageContent>
      </DataKindMaintenancePageStateProvider>
    </>
  );
};
